import React from "react";
import { View, Text, Button, Icon } from "ui";
import Dialog from "@material-ui/core/Dialog";

interface P {
  open: boolean;
  text: string;
  onClose?: () => void;
  onConfirm?: () => void;
}
export default class ConfirmDialog extends React.Component<P> {
  public render = () => {
    const { text, open, onClose, onConfirm } = this.props;
    return (
      <Dialog open={open} onClose={() => onClose}>
        <View flexDirection="column" p={2}>
          <Text fontSize={3}> {text} </Text>
          <View mt={2} justifyContent="space-between" alignItems="center">
            <Button bg="primary" onClick={() => onClose()}>
              <Icon name="close" size={1.5} color="white" />
            </Button>
            <Button bg="warning" onClick={() => onConfirm()}>
              <Icon name="check" size={1.5} color="white" />
            </Button>
          </View>
        </View>
      </Dialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ConfirmDialog.tsx